import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerGameList.module.scss';
import clsx from 'clsx';
import Block from '../Block/Block';
import { gamePartnerList } from '../../redux/actions/game/gamePartnerList';
import PartnerGameItem from '../PartnerGameItem/PartnerGameItem';
import EmptyText from '../EmptyText/EmptyText';
const PartnerGameList = () => {
  const dispatch = useDispatch();
  const {
    gamePartnerList: { data: gamePartnerListData, loading: gamePartnerListLoading, error: gamePartnerListError },
  } = useSelector((state) => state.game);
  useEffect(() => {
    dispatch(gamePartnerList());
  }, []);

  return (
    <>
      <Block title="Подключенные игры" className={styles.wrap}>
        {!gamePartnerListData?.length ? (
          <EmptyText>Подключенных игр нет</EmptyText>
        ) : (
          <div className={clsx(styles.grid)}>
            {gamePartnerListData?.map((item, index) => (
              <PartnerGameItem {...item} isLast={gamePartnerListData?.length - 1 == index} />
            ))}
          </div>
        )}
      </Block>
    </>
  );
};

export default PartnerGameList;
